import { createReducer } from '@reduxjs/toolkit';
import {
    NEW_DATA_TOP10,
    NEW_DATA_CATEGORIES,
    SET_IS_LOADING_TOP10,
    SET_NOT_FOUND_TOP10,
} from '../actions/Top10Actions';

const initialState = {
    dataTop10: [],
    dataCategories: [],
    lastIdCategory: null,
    isLoading: false,
    notFound: null,
};

const top10 = createReducer(initialState, (builder) => {
    builder
        .addCase(NEW_DATA_TOP10, (state, action) => {
            state.dataTop10 = action.dataTop10;
            state.lastIdCategory = action.lastIdCategory;
        })
        .addCase(NEW_DATA_CATEGORIES, (state, action) => {
            state.dataCategories = action.dataTop10Categories;
        })
        .addCase(SET_IS_LOADING_TOP10, (state, action) => {
            state.isLoading = action.isLoading;
        })
        .addCase(SET_NOT_FOUND_TOP10, (state, action) => {
            state.notFound = action.notFound;
        });
});

export default top10;
